import {apiPath} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import type {FinancialApplicationSource} from "../../application/types/financial_application";
import {getCbkAccountHeaders} from "../../application/utils/get_cbk_account_headers";
import type {IPaginatedConsentTemplateList} from "../types";

const consentsEndpoints = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getConsents: builder.query<IPaginatedConsentTemplateList, FinancialApplicationSource>({
            query: (source) => ({
                url: apiPath.applications.financialApplication.consents,
                headers: getCbkAccountHeaders(source)
            })
        })
    })
});

export const {useGetConsentsQuery} = consentsEndpoints;
import {apiPath} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import type {FinancialApplicationSource} from "../../application/types/financial_application";
import {getCbkAccountHeaders} from "../../application/utils/get_cbk_account_headers";
import type {IPaginatedConsentTemplateList} from "../types";

const consentsEndpoints = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getConsents: builder.query<IPaginatedConsentTemplateList, FinancialApplicationSource>({
            query: (source) => ({
                url: apiPath.applications.financialApplication.consents,
                headers: getCbkAccountHeaders(source)
            })
        })
    })
});

export const {useGetConsentsQuery} = consentsEndpoints;
